import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    "&.reverse": {
      flexDirection: "row-reverse",
    },
  },
});
